import { CanDeactivateFn } from '@angular/router';

/** CanDeactivateComponent */
export interface CanDeactivateComponent {
    hasPendingChanges(): boolean;
    confirmNavigation(): Promise<boolean>;
}

/**
 * PendingChangesGuard
 * @param component 
 * @returns 
 */
export const PendingChangesGuard: CanDeactivateFn<CanDeactivateComponent> = (component) => {

    if (!component.hasPendingChanges()) {
        return true;
    }

    return component.confirmNavigation();

};